import type { NamePool } from "@/core/types.js";

export const deNamePool: NamePool = {
  given: {
    male: [
      "Hans", "Klaus", "Dieter", "Werner", "Peter", "Michael", "Thomas",
      "Andreas", "Stefan", "Markus", "Christian", "Daniel", "Martin",
      "Frank", "Juergen", "Uwe", "Bernd", "Holger", "Rainer", "Guenter",
      "Wolfgang", "Matthias", "Alexander", "Tobias", "Sebastian",
      "Florian", "Jan", "Lukas", "Felix", "David", "Max", "Tim",
      "Nico", "Leon", "Jonas",
    ],
    female: [
      "Petra", "Sabine", "Claudia", "Karin", "Susanne", "Monika", "Helga",
      "Ingrid", "Ursula", "Renate", "Elisabeth", "Gisela", "Brigitte",
      "Margit", "Christina", "Andrea", "Nicole", "Sandra", "Stefanie",
      "Julia", "Lisa", "Laura", "Anna", "Sarah", "Katharina",
      "Lena", "Hannah", "Maria", "Sophie", "Emma", "Mia", "Lea",
      "Luisa", "Johanna", "Franziska",
    ],
  },
  family: [
    "Mueller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer",
    "Wagner", "Becker", "Schulz", "Hoffmann", "Schafer", "Koch",
    "Bauer", "Richter", "Klein", "Wolf", "Schroeder", "Neumann",
    "Schwarz", "Zimmermann", "Braun", "Krueger", "Hartmann", "Lange",
    "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid",
    "Schulze", "Maier", "Koehler", "Herrmann", "Koenig", "Walter",
    "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang",
    "Scholz", "Moeller", "Weiss", "Jung", "Hahn", "Schubert",
  ],
};
